module.exports = __webpack_public_path__ + "049f1e9dd2750b5880e1fc8840b0671d.pdf";